import React, { useContext, useState } from "react";
import * as GrIcons from "react-icons/gr";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";

import timeValues from "../../data/timeValues";

import moment from "moment";

const VirtualOrientationCard = ({ link, setLink, onSubmit }) => {
  return (
    <div className="virtual-orientation-form">
      <form onSubmit={onSubmit} className="group form">
        <div className="item">
          <h3>Orientation Link</h3>
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="Please Enter Orientation URL"
          />
        </div>
        <input
          type="submit"
          value="Send Email Invitation"
          className="btn btn-llac-dark-green"
        />
      </form>
    </div>
  );
};
const LiveOrientationCard = ({ time, setTime, onSubmit }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { orientation_info } = adminRegistrationContext;
  const [newTime, setNewTime] = useState({
    date: "",
    start_time: "",
    end_time: "",
  });
  const [showCustomDateButton, setShowCustomDateButton] = useState(
    orientation_info.orientation_dates &&
      orientation_info.orientation_dates.length < 1
  );

  const { date, start_time, end_time } = newTime;
  const customTimeCompleted =
    date !== "" && start_time !== "" && end_time !== "";

  const handleSubmit = () => {
    setTime(
      `${moment(date).utc().format("MM/DD/yyyy")} - ${start_time} - ${end_time}`
    );
    setShowCustomDateButton(false);
  };

  const handleOnChange = (e) => {
    setNewTime({ ...newTime, [e.target.name]: e.target.value });
  };
  return (
    <div className="live-orientation-form">
      <div className="group form">
        <div className="item">
          <h3>Select Orientation Date</h3>

          {orientation_info.orientation_dates &&
          orientation_info.orientation_dates.length > 0 ? (
            <select value={time} onChange={(e) => setTime(e.target.value)}>
              <option value="">Please Select An Orientation Date</option>
              {orientation_info.orientation_dates.map((item) => {
                const { date, start_time, end_time } = item;
                return (
                  <option
                    value={`${date} - ${start_time} - ${end_time}`}
                  >{`${date} - ${start_time} - ${end_time}`}</option>
                );
              })}
            </select>
          ) : (
            <div className="date-select">
              <input
                type="date"
                name="date"
                value={date}
                onChange={(e) => handleOnChange(e)}
              />
              <div className="time">
                <div className="left">
                  <p>From</p>
                  <select
                    name="start_time"
                    value={start_time}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option value="">Start Time</option>
                    {timeValues.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
                <div className="right">
                  <p>To</p>
                  <select
                    name="end_time"
                    value={end_time}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option value="">End Time</option>
                    {timeValues.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
        {showCustomDateButton ? (
          <div
            className="btn btn-llac-dark-grey date-select-btn"
            onClick={handleSubmit}
          >
            Add Date
          </div>
        ) : (
          <div
            className="btn btn-llac-dark-green date-select-btn"
            onClick={onSubmit}
          >
            Submit
          </div>
        )}
      </div>
    </div>
  );
};

const OrientationModal = ({ type, history }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const authContext = useContext(AuthContext);
  const [orientationType, setOrientationType] = useState("VIRTUAL");
  const { setFormModal, registration, sendOrientationEmail, orientation_info } =
    adminRegistrationContext;
  const { user } = authContext;
  const [orientationTime, setOrientationTime] = useState("");
  const [virtualLink, setVirtualLink] = useState(
    orientation_info.virtual_link ? orientation_info.virtual_link : ""
  );

  const handlePostSubmit = () => {
    const {
      _id,
      firstName,
      lastName,
      learningCenterName,
      learningCenterCharter,
      learningCenterCoordinates,
      studentEmail,
    } = registration;
    let emailFormData = {
      type,
      id: _id,
      name: `${firstName} ${lastName}`,
      location: learningCenterName,
      charter: learningCenterCharter,
      coordinates: learningCenterCoordinates,
      staffEmail: user.azureID,
      studentEmail,
    };

    if (orientationType === "VIRTUAL") {
      emailFormData.orientationLink = virtualLink;
      sendOrientationEmail(emailFormData, orientationType, type);
    } else {
      emailFormData.orientationTime = orientationTime;
      sendOrientationEmail(emailFormData, orientationType, type);
    }
    setFormModal("orientationModal", false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handlePostSubmit();
  };

  return (
    <div id="orientation-modal" className="modal">
      <div className="orientation-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("orientationModal", false)}
          />
          <h2>Orientation Scheduler</h2>
        </div>
        <div className="modal-body">
          <div className="flex-check-container">
            <label className="check-container">
              Virtual Orientation
              <input
                type="radio"
                value="no"
                checked={orientationType === "VIRTUAL"}
                onChange={() => setOrientationType("VIRTUAL")}
                name="registerForIntercession"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              Live Orientation
              <input
                type="radio"
                value="yes"
                checked={orientationType === "LIVE"}
                onChange={() => setOrientationType("LIVE")}
                name="registerForIntercession"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
          {orientationType === "VIRTUAL" && (
            <VirtualOrientationCard
              link={virtualLink}
              setLink={setVirtualLink}
              onSubmit={onSubmit}
            />
          )}
          {orientationType === "LIVE" && (
            <LiveOrientationCard
              time={orientationTime}
              setTime={setOrientationTime}
              onSubmit={onSubmit}
            />
          )}
        </div>
        <div className="bottom-bar">
          <div className="btns">
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("orientationModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrientationModal;
